import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";

interface properties {
  HandleClose?: () => void;
  HandleAccept?: () => void;
  IsOpen: boolean;
  Message: string;
  YesBtnText: string;
  NoBtnText: string;
  Title: string;
  disabled?: boolean;
}

export default function AlertDialog(props: properties): React.JSX.Element {
  const { disabled = false } = props;
  return (
    <div>
      <Dialog open={props.IsOpen} onClose={props.HandleClose}>
        <DialogTitle>{props.Title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{props.Message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.HandleClose && (
            <Button onClick={props.HandleClose} color="secondary">
              {props.NoBtnText}
            </Button>
          )}
          {props.HandleAccept && (
            <Button
              onClick={props.HandleAccept}
              color="primary"
              autoFocus
              disabled={disabled}
            >
              {props.YesBtnText}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
